export default __webpack_public_path__ + "static/media/Tasset of Tribulation.5c1499da.jpg";